export default __webpack_public_path__ + "static/media/event_post_step.37f108e1.png";